export default {
  NONE: "",
  BEGGINER: "Beginner",
  ADVANCED: "Advanced",
  INTERMEDIATE: "Intermediate"
};
